<template>
    <modal v-model="showModal" title="Generate File Notes Report" @hide="close" ref="modal" size="md" ok-text="Run Report">
        <div class="report-modal-wrapper">
            <div class="row">
                <label class="col-sm-4 control-label">From Date:</label>
                <div class="col-sm-8">
                    <datepicker v-model="startDate" :calendar-button="true" calendar-button-icon="fa fa-calendar"
                                :clear-button="true" clear-button-icon="fa fa-times" :bootstrap-styling="true"
                                format="yyyy MMM dd" :typeable="isTypeable"></datepicker>
                </div>
            </div>
            <div class="row">
                <label class="col-sm-4 control-label">To Date:</label>
                <div class="col-sm-8">
                    <datepicker v-model="endDate" :calendar-button="true" calendar-button-icon="fa fa-calendar"
                                :clear-button="true" clear-button-icon="fa fa-times" :bootstrap-styling="true"
                                format="yyyy MMM dd" :typeable="isTypeable"></datepicker>
                </div>
            </div>
        </div>
    </modal>
</template>
<script>
    import Vue from "vue";
    import { Modal } from 'uiv';
    import Datepicker from 'vuejs-datepicker';
    import axios from 'axios';
    import { shortDateFormat } from '../../_shared/date-utils';

    Vue.component("datepicker", Datepicker);
    
    export default {
        data: function () {
            return {
                showModal: false,
                startDate: null,
                endDate: null
            };
        },
        methods: {
            show() {
                this.showModal = true;
            },
            close(msg) {
                if (msg === 'ok') {
                    let branchId = this.$store.state.branchId;
                    let fileId = this.$store.state.fileId;
                    let start = encodeURIComponent(shortDateFormat(this.startDate, "-"));
                    let end = encodeURIComponent(shortDateFormat(this.endDate, "-"));
                    let url = `/core/sso/OpenKeaView?KVDestPage=UI/Reports/ReportViewer.aspx?Report=175%26@branch=${branchId}%26@file=${fileId}%26@FromDate=${start}%26@ToDate=${end}`;
                    window.open(url, 'KeaviewWindow');
                }
            }
        },
        computed: {
            isTypeable() {
                // there is a bug in Safari with the datepicker
                // https://stackoverflow.com/a/23522755/2616170
                !/^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            }
        },
        components: {
            Modal
        },
        created() {
            let branchId = this.$store.state.branchId;
            let fileId = this.$store.state.fileId;
            var url = `/core/api/timeexpenses/${branchId}/${fileId}/startdate`;
            axios.get(url)
                .then(response => {
                    if (response.data.firstTimeExpenseDate !== null) {
                        this.startDate = new Date(response.data.firstTimeExpenseDate);
                        this.startDate.setHours(0, 0, 0, 0);
                    }
                    this.endDate = new Date();
                    this.endDate.setHours(0, 0, 0, 0);
                })
        }
    };
</script>

<style lang="scss">
    .report-modal-wrapper {
        padding: 15px;

        & > .row:first-child {
            margin-bottom: 20px;

        }
    }

    @media (min-width: 768px) {
        .modal-dialog.modal-md {
            width: 420px;
        }
    }

    .modal-dialog .modal-footer {
        button .btn.btn-default
        {
            float: right !important;
        }
    }
</style>
